import { Upload, Loader2, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { mediaUrl } from "@/lib/api";
import { CURRENCIES, CURRENCY_LABEL } from "@/lib/contactChannels";

const LABEL = "text-xs uppercase tracking-wide font-bold text-slate-500";

export function PricingSection({ form, set, setForm }) {
  const isRange = form.price_type === "range";
  return (
    <div className="space-y-3">
      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <Label className={LABEL}>Monedă</Label>
          <select value={form.currency} onChange={(e) => setForm({ ...form, currency: e.target.value })} className="w-full border border-slate-300 h-10 px-2 text-sm bg-white mt-1.5" data-testid="listing-currency">
            {CURRENCIES.map((c) => <option key={c} value={c}>{CURRENCY_LABEL[c]}</option>)}
          </select>
        </div>
        <div className="flex items-end gap-4 pb-1">
          <label className="flex items-center gap-2 cursor-pointer text-sm">
            <input type="radio" name="ptype" checked={!isRange} onChange={() => setForm({ ...form, price_type: "fixed" })} data-testid="ptype-fixed" /> Preț fix
          </label>
          <label className="flex items-center gap-2 cursor-pointer text-sm">
            <input type="radio" name="ptype" checked={isRange} onChange={() => setForm({ ...form, price_type: "range" })} data-testid="ptype-range" /> Interval de preț
          </label>
        </div>
      </div>
      {!isRange ? (
        <div className="grid sm:grid-cols-2 gap-4 items-end">
          <div>
            <Label className={LABEL}>Preț ({form.currency})</Label>
            <Input type="number" value={form.price} disabled={form.price_on_request} onChange={set("price")} placeholder="0" className="rounded-none mt-1.5" data-testid="listing-price" />
          </div>
          <label className="flex items-center gap-2 pb-2.5 cursor-pointer">
            <Checkbox checked={form.price_on_request} onCheckedChange={(v) => setForm({ ...form, price_on_request: !!v })} data-testid="listing-price-on-request" />
            <span className="text-sm text-slate-700">Preț la cerere</span>
          </label>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 gap-4">
          <div>
            <Label className={LABEL}>De la ({form.currency})</Label>
            <Input type="number" value={form.price_min} onChange={set("price_min")} placeholder="20000" className="rounded-none mt-1.5" data-testid="listing-price-min" />
          </div>
          <div>
            <Label className={LABEL}>Până la ({form.currency})</Label>
            <Input type="number" value={form.price_max} onChange={set("price_max")} placeholder="30000" className="rounded-none mt-1.5" data-testid="listing-price-max" />
          </div>
        </div>
      )}
    </div>
  );
}

export function MachineDetails({ specs, setSpec, visible }) {
  if (!visible) return null;
  return (
    <div>
      <Label className={LABEL}>Specificații tehnice</Label>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mt-1.5">
        <Input type="number" placeholder="Putere kW" value={specs.motor_power_kw} onChange={setSpec("motor_power_kw")} className="rounded-none" />
        <Input type="number" placeholder="Arbore mm" value={specs.spindle_diameter_mm} onChange={setSpec("spindle_diameter_mm")} className="rounded-none" />
        <Input type="number" placeholder="Greutate kg" value={specs.weight_kg} onChange={setSpec("weight_kg")} className="rounded-none" />
        <Input type="number" placeholder="Turație rpm" value={specs.max_rpm} onChange={setSpec("max_rpm")} className="rounded-none" />
        <Input type="number" placeholder="An" value={specs.year} onChange={setSpec("year")} className="rounded-none" />
      </div>
    </div>
  );
}

export function MediaUpload({ images, onFiles, uploading, removeImage }) {
  return (
    <div>
      <Label className={LABEL}>Fotografii</Label>
      <label className="mt-1.5 flex flex-col items-center justify-center gap-2 w-full min-h-[7rem] border-2 border-dashed border-slate-300 cursor-pointer hover:border-orange-500 hover:bg-orange-50/40 transition-colors text-slate-400 hover:text-orange-600 p-4" data-testid="upload-image-label">
        {uploading ? <Loader2 className="w-7 h-7 animate-spin" /> : <Upload className="w-7 h-7" />}
        <span className="text-sm font-bold uppercase tracking-wide">Adaugă fotografii</span>
        <span className="text-xs text-slate-400">Atinge pentru a alege din galerie sau a face o poză</span>
        <input type="file" accept="image/*" multiple className="hidden" onChange={onFiles} disabled={uploading} data-testid="upload-image-input" />
      </label>
      {images.length > 0 && (
        <div className="flex flex-wrap gap-3 mt-3">
          {images.map((img) => (
            <div key={img.path} className="relative w-24 h-24 border border-slate-200">
              <img src={mediaUrl(img.url)} alt="preview" className="w-full h-full object-cover" />
              <button onClick={() => removeImage(img.path)} className="absolute -top-2 -right-2 bg-slate-900 text-white rounded-full p-1" data-testid="remove-image"><X className="w-3 h-3" /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
